/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  getAIConversations,
  getAIMessages,
  updateAIMessages,
  getAllCollections,
  addNewCollection,
  toggleMessageInCollection,
  updateCollection,
  deleteAIMessage,
  updateAiConversation,
  assignAgentJob,
  getK3Tasks,
  getK3Agents
} from '../actions';
import {
  replaceAllText
} from "../utils";
import { CircleSpinnerOverlay, FerrisWheelSpinner } from 'react-spinner-overlay';
import { BsFillSuitHeartFill, BsFillBookmarkPlusFill, BsDownload, BsClipboardCheck, BsLink45Deg, BsFileEarmarkText, BsChatSquareText, BsArrowUpCircleFill, BsTrash, BsArrowDownCircleFill, BsFileEarmarkArrowDown, BsX, BsChevronDown, BsChevronUp, BsArrowClockwise } from "react-icons/bs";
import { AiFillFileMarkdown } from "react-icons/ai";
import { TbSourceCode } from "react-icons/tb";
import { CONFIGS } from "../configs";
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Collapse,
  Modal,
  Table,
  ButtonGroup,
  Dropdown
} from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';
import rehypeSlug from 'rehype-slug';
import remarkToc from 'remark-toc';
import rehypeHighlight from 'rehype-highlight';
import rehypeAutolinkHeadings from 'rehype-autolink-headings';
import rehypeSanitize from 'rehype-sanitize';

import ImageModal from '../components/ImageModal';
import MarkdownVideo from '../components/MarkdownVideo';
import CommitCreator from '../components/CommitCreator';
import debounce from 'lodash/debounce';
import JSZip from 'jszip';
import Select from 'react-select';

// Tách component InputWithButton để chỉ render lại khi cần
const InputWithButton = React.memo(({ 
  value, 
  onChange, 
  placeholder, 
  label, 
  buttonText, 
  buttonVariant, 
  onButtonClick, 
  disabled 
}) => {
  return (
    <InputGroup className="mb-3">
      <InputGroup.Text className="btn-sm">{label}</InputGroup.Text>
      <Form.Control
        className='text-red'
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        aria-label="keyword"
        aria-describedby="basic-addon1"
      />
      <Button
        className="btn-fill btn-sm"
        type="submit"
        variant={buttonVariant}
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
    </InputGroup>
  );
});

// Tách component MessageList để tránh re-render không cần thiết
const MessageList = React.memo(({ messages, renderMessage, isSelectionMode, selectedMessages }) => {
  return (
    <>
      {messages.map((message, idx) =>
        renderMessage(message, idx + 1, messages.length, isSelectionMode, selectedMessages)
      )}
    </>
  );
});

// Tách component MessageHeader để tránh re-render không cần thiết
const MessageHeader = React.memo(({ keyword, filterKeyword, isFilterByKeyword, messageCount, messages }) => {
  let textMessage = "";
  
  if (keyword) {
    textMessage += `Hiển thị kết quả cho keyword "${keyword}"`;
  }
  if (filterKeyword && isFilterByKeyword) {
    if (textMessage) textMessage += " và ";
    textMessage += `filter keyword "${filterKeyword}"`;
  }
  if (!keyword && (!filterKeyword || !isFilterByKeyword)) {
    textMessage = "Hiển thị";
  }
  
  // Tính tổng số token
  const totalTokens = messages.reduce((sum, message) => {
    if (!message.message) {
      return 0;
    }
    const content = message.content_markdown_v1 || message.message.content.parts.join("\n");
    const charCount = content.length;
    const wordCount = content.trim().split(/\s+/).length;
    const estimatedTokens = Math.max(
      Math.ceil(charCount / 4),
      Math.ceil(wordCount / 0.75)
    );
    return sum + estimatedTokens;
  }, 0);
  
  // Làm tròn tổng số token lên đơn vị nghìn
  const roundedTotalTokens = Math.ceil(totalTokens / 1000) * 1000;
  const displayTotalTokens = roundedTotalTokens >= 1000 ? `${(roundedTotalTokens/1000).toFixed(1)}k` : roundedTotalTokens;
  
  textMessage += messageCount > 0 ? `: ${messageCount} tin nhắn (${displayTotalTokens} tokens)` : ``;

  return messageCount > 0 ? <h4>{textMessage}</h4> : null;
});

class K3PLChat extends Component {
  constructor(props) {
    super();
    this.state = {
      collectionId: "",
      aiConversations: [],
      aiMessages: null,
      filteredMessages: [],
      showContentMarkdownV1: localStorage.getItem('showContentMarkdownV1') === 'true',
      showToolMessages: localStorage.getItem('showToolMessages') === 'true',
      showAllMessages: localStorage.getItem('showAllMessages') === 'true',
      showMenu: new URLSearchParams(window.location.search).get('show_menu') !== 'false',
      query: this.initQuery,
      currentPopupMessageId: '',
      collections: [],
      currentCollection: {},
      newCollectionName: "",
      selectedCollectionId: "",
      isFilterByKeyword: false,
      searchInput: "",
      filterInput: "",
      messageId: "",
      showScrollTop: false,
      showScrollBottom: false,
      selectedMessages: new Set(),
      isSelectionMode: false,
      messageA: null,
      messageB: null,
      isLoading: true,
      showSourceModal: false,
      currentSourceMessage: null,
      collapsedMessages: JSON.parse(localStorage.getItem('collapsedMessages') || '{}'),
      selectedChatTask: '',
      chatMessage: '',
      k3tasks: [],
      k3agents: [],
      showImportMessages: localStorage.getItem('showImportMessages') === 'true',
      messagePollInterval: null,
      viewMode: localStorage.getItem('viewMode') || '2-column', // Add view mode state
    };

    this.aiMessageMarkdownObj = {};
    this.keyword = "";
    this.preRole = "";
    this.messagesByRole = [];

    // Bind các hàm xử lý onChange
    this.handleChangeKeyword = this.handleChangeKeyword.bind(this);
    this.handleChangeKeywordClient = this.handleChangeKeywordClient.bind(this);
    this.handleMessageSelect = this.handleMessageSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleDeselectAll = this.handleDeselectAll.bind(this);
    this.handleToggleSelectionMode = this.handleToggleSelectionMode.bind(this);
  }

  initQuery = {
    conversationId: "",
    keyword: "",
    filterKeyword: "",
    messageId: ""
  };

  componentDidMount() {
    // Load query from URL
    const searchParams = new URLSearchParams(window.location.search);
    const query = {
      conversationId: searchParams.get('conversationId') || "",
      keyword: searchParams.get('keyword') || "",
      filterKeyword: searchParams.get('filterKeyword') || "",
      messageId: searchParams.get('messageId') || ""
    };

    // Set initial state from URL parameters
    this.setState({ 
      query,
      searchInput: query.keyword || "",
      filterInput: query.filterKeyword || "",
      isFilterByKeyword: !!query.filterKeyword,
      messageId: query.messageId || "",
      showMenu: searchParams.get('show_menu') !== 'false'
    }, () => {
      if (query.conversationId || query.keyword || query.messageId) {
        this.props.getAIMessages(query);
      }
    });

    var collectionId = this.props.match.params.id;
    if (collectionId) {
      this.setState({ 
        collectionId,
        isLoading: true 
      });
    } else {
      this.props.getAIConversations();
    }

    this.props.getAllCollections();

    // Thêm event listener cho scroll của container
    const container = this.findScrollableContainer();
    if (container) {
      container.addEventListener('scroll', this.handleScroll);
    }

    this.props.getK3Tasks();
    this.props.getK3Agents();

    const savedTask = localStorage.getItem('selectedChatTask');
    if (savedTask) {
      this.setState({ selectedChatTask: savedTask });
    }
  }

  componentWillUnmount() {
    // Xóa event listener khi component unmount
    const container = this.findScrollableContainer();
    if (container) {
      container.removeEventListener('scroll', this.handleScroll);
    }
    // Clear any existing polling interval
    if (this.state.messagePollInterval) {
      clearInterval(this.state.messagePollInterval);
    }
  }

  findScrollableContainer = () => {
    // Tìm container chứa danh sách messages
    const container = document.querySelector('#k3pl-chat-page div[style*="overflow-y: auto"]');
    if (!container) return null;
    return container;
  }

  handleScroll = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    
    // Hiển thị nút scroll to top khi scroll xuống quá 300px
    const showScrollTop = scrollTop > 300;
    // Hiển thị nút scroll to bottom khi chưa scroll đến cuối
    const showScrollBottom = scrollHeight - scrollTop - clientHeight > 300;
    
    if (this.state.showScrollTop !== showScrollTop || this.state.showScrollBottom !== showScrollBottom) {
      this.setState({ 
        showScrollTop,
        showScrollBottom
      });
    }
  }

  scrollToTop = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    container.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  scrollToBottom = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  }

  updateURLQuery = (query) => {
    const searchParams = new URLSearchParams();
    if (query.conversationId) searchParams.set('conversationId', query.conversationId);
    if (query.keyword) searchParams.set('keyword', query.keyword);
    if (query.filterKeyword) searchParams.set('filterKeyword', query.filterKeyword);
    if (query.messageId) searchParams.set('messageId', query.messageId);
    
    const newURL = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
    window.history.pushState({}, '', newURL);
  }

  componentDidUpdate(prevProps, prevState) {
    const messages = this.state.aiMessages || [];
    
    if (prevState.aiMessages !== this.state.aiMessages ||
        prevState.showAllMessages !== this.state.showAllMessages ||
        prevState.showToolMessages !== this.state.showToolMessages ||
        prevState.showContentMarkdownV1 !== this.state.showContentMarkdownV1 ||
        prevState.viewMode !== this.state.viewMode) {
      if (this.state.messageId) {
        const message = messages.find(m => m.id === this.state.messageId);
        this.setState({ filteredMessages: message ? [message] : [] });
      } else {
        this.messagesByRole = this.filterMessagesByRole(messages);
        this.updateFilteredMessages();
      }

      // Apply collapsed state after messages are loaded
      setTimeout(() => {
        const collapsedMessages = JSON.parse(localStorage.getItem('collapsedMessages') || '{}');
        Object.keys(collapsedMessages).forEach(messageId => {
          const messageElement = document.querySelector(`[data-message-id="${messageId}"]`);
          if (messageElement) {
            messageElement.classList.add('collapsed');
            messageElement.style.height = '120px';
            
            // Update icon
            const iconElement = messageElement.querySelector('.btn-collapse-message');
            if (iconElement) {
              iconElement.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path></svg>';
            }
          }
        });
      }, 100);

      // Set tooltips for all messages
      setTimeout(() => {
        document.querySelectorAll('[data-message-id]').forEach(messageElement => {
          const button = messageElement.querySelector('.btn-collapse-message');
          if (button) {
            button.title = messageElement.classList.contains('collapsed') ? 
              'Hiện đầy đủ message' : 
              'Thu gọn message';
          }
        });
      }, 150);
    } else if (prevState.query.filterKeyword !== this.state.query.filterKeyword ||
               prevState.isFilterByKeyword !== this.state.isFilterByKeyword) {
      this.messagesByRole = this.filterMessagesByRole(messages);
      this.updateFilteredMessages();
    }
  }

  filterMessagesByRole = (messages) => {
    let filtered = messages;
    if (this.state.showAllMessages) {
      filtered = messages;
    } else {
      filtered = messages.filter(message => {
        const role = this.getAIMessageRole(message);
        return this.state.showToolMessages ? 
          ["assistant", "user", "assistant_tool", "system"].includes(role) :
          ["assistant", "user", "system"].includes(role);
      });
    }

    // Hide Import Messages logic
    if (!this.state.showImportMessages) {
      // Tìm các message A
      const isMsgA = (msg) => {
        return msg.content_markdown && msg.content_markdown.includes('K3PACKAGE_IMPORT_V1.0 - Step 1: Import K3 Package and Knowledge Testing');
      };
      // Tìm các message B
      const isMsgB = (msg) => {
        return msg.content_markdown &&
          msg.content_markdown.includes('@K3PACKAGE_IMPORT_V1.0_STEP2_RESULT') &&
          msg.content_markdown.includes('Chúc mừng bạn đã import package thành công !');
      };
      // Tìm index các message A
      const msgAIndexes = filtered.map((msg, idx) => isMsgA(msg) ? idx : -1).filter(idx => idx !== -1);
      console.log("@msgAIndexes", msgAIndexes);
      let toHide = new Set();
      for (const aIdx of msgAIndexes) {
        // Tìm B đầu tiên sau A
        let bIdx = -1;
        for (let i = aIdx + 1; i < filtered.length; ++i) {
          if (isMsgB(filtered[i])) {
            bIdx = i;
            break;
          }
        }
        if (bIdx > aIdx) {
          // Ẩn cả A và các message ở giữa, chỉ giữ lại B
          for (let i = aIdx; i < bIdx; ++i) {
            toHide.add(filtered[i].id);
          }
        }
      }
      filtered = filtered.filter(msg => !toHide.has(msg.id));
    }
    return filtered;
  }

  updateFilteredMessages = () => {
    const messages = this.state.aiMessages || [];
    const { filterKeyword } = this.state.query;
    const trimmedFilterKeyword = filterKeyword.trim().toLowerCase();

    if (!this.messagesByRole) {
      this.messagesByRole = this.filterMessagesByRole(messages);
    }

    let filteredMessages = this.messagesByRole || [];

    if (trimmedFilterKeyword && this.state.isFilterByKeyword) {
      filteredMessages = filteredMessages.filter(message => 
        message.content_markdown_v1 && 
        message.content_markdown_v1.toLowerCase().includes(trimmedFilterKeyword)
      );
    }

    // Sắp xếp filteredMessages theo _id
    filteredMessages.sort((a, b) => a._id.localeCompare(b._id));

    this.setState({ filteredMessages });
  }

  filterAIMessages = (inputMessages = []) => {
    const messages = inputMessages || [];
    const { filterKeyword } = this.state.query;
    const trimmedFilterKeyword = filterKeyword.trim().toLowerCase();

    let filteredMessages = (this.messagesByRole || []).length > 0 ? 
      this.messagesByRole : 
      this.filterMessagesByRole(messages);

    if (trimmedFilterKeyword && this.state.isFilterByKeyword) {
      filteredMessages = filteredMessages.filter(message => 
        message.content_markdown_v1 && 
        message.content_markdown_v1.toLowerCase().includes(trimmedFilterKeyword)
      );
    }

    return filteredMessages;
  }

  componentWillReceiveProps(props) {
    var { currentCollection } = this.state;

    if (this.state.collectionId && props.collections.length > 0) {
      currentCollection = props.collections.filter(collection => collection._id == this.state.collectionId)[0];

      if (currentCollection._id != this.state.currentCollection._id && currentCollection.message_ids)
        this.props.getAIMessages({ messageIds: currentCollection.message_ids });
    }

    const messagesChanged = 
      this.state.aiMessages === null ||
      props.aiMessages.length !== this.state.aiMessages.length ||
      props.aiMessages.some((msg, idx) => 
        !this.state.aiMessages[idx] || msg.id !== this.state.aiMessages[idx].id
      );

    console.log('messagesChanged', messagesChanged, this.state.aiMessages, props.aiMessages);

    this.setState({
      aiConversations: props.aiConversations,
      aiMessages: props.aiMessages,
      collections: props.collections,
      currentCollection
    });

    // Delay tắt loading 1s sau khi messages thay đổi
    if (messagesChanged) {
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 1000);
    }

    if (props.k3tasks) {
      this.setState({ k3tasks: props.k3tasks });
    }
    if (props.k3agents) {
      this.setState({ k3agents: props.k3agents });
    }
  }

  getAIMessageRole = (message) => {
    var role = "assistant_undefined";

    try {
      role = message.message.author.role;
      if (role == "tool") {
        role = "assistant_tool";
      } else if (role == "system") {
        role = "assistant_system";
      }
    } catch (e) {
      console.log(e);
    }

    return role;
  }

  // Thêm hàm tính token
  calculateTokens = (text) => {
    try {
      // Ước tính số token dựa trên số ký tự và từ
      // 1 token ≈ 4 ký tự hoặc 0.75 từ
      const charCount = text.length;
      const wordCount = text.trim().split(/\s+/).length;
      const estimatedTokens = Math.max(
        Math.ceil(charCount / 4),
        Math.ceil(wordCount / 0.75)
      );
      return estimatedTokens;
    } catch (error) {
      console.error('Error calculating tokens:', error);
      return 0;
    }
  }

  handleClick(e) {
    const el = (sel, par) => (par || document).querySelector(sel);
    const elPopup = el("#popup-add-to-collection");
    Object.assign(elPopup.style, {
      display: `none`
    });
  }

  showPopupAddToCollection = (evt, messageId) => {
    evt.stopPropagation();
    this.setState({ selectedMessageId: messageId });
    // const el = (sel, par) => (par||document).querySelector(sel);
    // const elListingPage = el("#listing-page");
    // const elPopup = el("#popup-add-to-collection");

    const elListing = document.getElementById("k3pl-chat-page");
    var clientRect = elListing.getBoundingClientRect();
    var clientX = clientRect.left;
    var clientY = clientRect.top;
    var widthListing = clientRect.width;

    const elPopup = document.getElementById("popup-add-to-collection");
    var clientRectPopup = elPopup.getBoundingClientRect();
    var widthPopup = clientRectPopup.width;

    console.log('evt', evt, clientX, clientY);
    var dx = 30;
    var dy = 30;

    var left = Math.min(evt.clientX - clientX + dx);

    if (left + widthPopup > widthListing)
      left = left - widthPopup - dx;

    var right = evt.clientY - clientY + dy;

    Object.assign(elPopup.style, {
      left: `${left}px`,
      top: `${right}px`,
      display: `block`,
    });
  }

  downloadMessageContent = (message) => {
    if (!message.content_markdown_v1) return;
    
    let content = message.content_markdown_v1;
    let filename = `message.md`;

    // Kiểm tra và xử lý tên file đặc biệt
    const filenameMatch = content.match(/@K3PL_SAVE_MESSAGE_FILENAME:\s*(.+?)(?:\n|$)/);
    if (filenameMatch) {
      // Lấy tên file từ match
      filename = filenameMatch[1].trim();
      // Xóa dòng chứa tên file khỏi nội dung
      content = content.replace(/@K3PL_SAVE_MESSAGE_FILENAME:\s*(.+?)(?:\n|$)/, '');
      // Thay thế dấu : bằng dấu -
      filename = filename.replace(/:/g, 'h');
    } else {
      // Tạo tên file theo định dạng mới
      const role = this.getAIMessageRole(message);
      const date = message.message && message.message.create_time? new Date(message.message.create_time * 1000): "";
      const formattedDate = date? date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/[\/:]/g, '').replace(/,/g, '_'): "no-data";
      
      filename = `message_${formattedDate}_${role}.md`;
    }
    
    // Thêm thông tin conversation_id và message_id vào cuối file
    content += `\n\nCONVERSATION_ID = ${message.conversation_id}\nMESSAGE_ID = ${message.id}`;
    
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    
    toast.success('Đã tải xuống nội dung markdown!');
  }

  copyMessageContent = (message) => {
    const content = message.content_markdown_v1 || message.message.content.parts.join("\n");
    const messageUrl = `${window.location.origin}/v1/k3pl-chat?messageId=${message.id}`;
    const fullContent = `🔗 [View message](${messageUrl}) (ID: ${message.id})\n\n---\n\n${content}`;
    
    navigator.clipboard.writeText(fullContent).then(() => {
      toast.success('Đã sao chép nội dung!');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      toast.error('Không thể sao chép nội dung!');
    });
  }

  handleDeleteMessage = async (messageId) => {
    try {
      await this.props.deleteAIMessage(messageId);
      toast.success('Đã xóa tin nhắn!');
      
      // Nếu đang ở mode Message, chuyển hướng về trang chính
      if (this.state.messageId) {
        window.location.href = '/v1/k3pl-chat';
      }
    } catch (error) {
      console.error('Error deleting message:', error);
      toast.error('Không thể xóa tin nhắn!');
    }
  }

  handleMessageSelect = (messageId) => {
    const newSelectedMessages = new Set(this.state.selectedMessages);
    if (newSelectedMessages.has(messageId)) {
      newSelectedMessages.delete(messageId);
    } else {
      newSelectedMessages.add(messageId);
    }

    // Cập nhật message A và B
    let messageA = this.state.messageA;
    let messageB = this.state.messageB;
    
    if (newSelectedMessages.size === 1) {
      // Nếu chỉ có 1 message được chọn, đó là message A
      messageA = messageId;
      messageB = null;
    } else if (newSelectedMessages.size === 2) {
      // Nếu có 2 message được chọn, message thứ 2 là message B
      const selectedArray = Array.from(newSelectedMessages);
      messageA = selectedArray[0];
      messageB = selectedArray[1];
    }

    // Sắp xếp selectedMessages theo thứ tự hiển thị
    const sortedSelectedMessages = new Set(
      this.state.filteredMessages
        .filter(message => newSelectedMessages.has(message.id))
        .map(message => message.id)
    );

    console.log('sortedSelectedMessages', sortedSelectedMessages);

    this.setState({ 
      selectedMessages: sortedSelectedMessages,
      messageA,
      messageB
    }, () => {
      console.log('Selected messages:', Array.from(this.state.selectedMessages));
    });
  }

  handleSelectAll = () => {
    const { filteredMessages } = this.state;
    const newSelectedMessages = new Set();
    
    // Tạo mapping object giữa id và _id
    const idTo_id = {};
    filteredMessages.forEach(message => {
      idTo_id[message.id] = message._id;
    });
    
    if (this.state.selectedMessages.size === filteredMessages.length) {
      // Nếu đã chọn tất cả thì bỏ chọn hết
      this.setState({ selectedMessages: newSelectedMessages });
    } else {
      // Nếu chưa chọn tất cả thì chọn tất cả theo thứ tự _id
      const sortedIds = filteredMessages
        .map(message => message._id)
        .sort((a, b) => a.localeCompare(b));
      
      sortedIds.forEach(_id => {
        // Tìm id tương ứng với _id
        const id = Object.keys(idTo_id).find(key => idTo_id[key] === _id);
        if (id) {
          newSelectedMessages.add(id);
        }
      });
      
      this.setState({ selectedMessages: newSelectedMessages });
    }
  };

  handleDeselectAll = () => {
    this.setState({ selectedMessages: new Set() });
  }

  handleToggleSelectionMode = () => {
    const newIsSelectionMode = !this.state.isSelectionMode;
    this.setState({ 
      isSelectionMode: newIsSelectionMode,
      selectedMessages: new Set() // Reset selected messages when toggling mode
    });
  }

  handleToggleViewMode = () => {
    const newViewMode = this.state.viewMode === '2-column' ? '1-column' : '2-column';
    this.preRole = ""; // Reset preRole for proper layout
    this.setState({ 
      viewMode: newViewMode
    }, () => {
      // Force re-render by updating filteredMessages
      const messages = this.state.aiMessages || [];
      this.messagesByRole = this.filterMessagesByRole(messages);
      this.updateFilteredMessages();
    });
    localStorage.setItem('viewMode', newViewMode);
  }

  handleSelectAB = () => {
    if (!this.state.messageA || !this.state.messageB) {
      toast.error("Please select two messages first (A and B)");
      return;
    }

    const { filteredMessages } = this.state;
    
    // Tạo mapping object giữa id và _id
    const idTo_id = {};
    filteredMessages.forEach(message => {
      idTo_id[message.id] = message._id;
    });

    // Tìm vị trí của message A và B trong filteredMessages dựa trên _id
    const messageAIndex = filteredMessages.findIndex(m => m._id === idTo_id[this.state.messageA]);
    const messageBIndex = filteredMessages.findIndex(m => m._id === idTo_id[this.state.messageB]);

    if (messageAIndex === -1 || messageBIndex === -1) {
      toast.error("Could not find selected messages in filtered messages");
      return;
    }

    // Xác định start và end index
    const startIndex = Math.min(messageAIndex, messageBIndex);
    const endIndex = Math.max(messageAIndex, messageBIndex);

    // Chọn tất cả message từ start đến end theo thứ tự _id
    const newSelectedMessages = new Set();
    const sortedMessages = filteredMessages
      .slice(startIndex, endIndex + 1)
      .sort((a, b) => a._id.localeCompare(b._id));

    sortedMessages.forEach(message => {
      newSelectedMessages.add(message.id);
    });

    this.setState({ 
      selectedMessages: newSelectedMessages,
      messageA: null,
      messageB: null
    });
  };

  handleSelectAZ = () => {
    if (!this.state.messageA) {
      toast.error("Please select message A first");
      return;
    }

    const { filteredMessages } = this.state;

    // Tạo mapping object giữa id và _id
    const idTo_id = {};
    filteredMessages.forEach(message => {
      idTo_id[message.id] = message._id;
    });

    const messageAIndex = filteredMessages.findIndex(m => m._id === idTo_id[this.state.messageA]);

    if (messageAIndex === -1) {
      toast.error("Could not find message A in filtered messages");
      return;
    }

    // Chọn tất cả message từ A đến cuối theo thứ tự _id
    const newSelectedMessages = new Set();
    const sortedMessages = filteredMessages
      .slice(messageAIndex)
      .sort((a, b) => a._id.localeCompare(b._id));

    sortedMessages.forEach(message => {
      newSelectedMessages.add(message.id);
    });

    this.setState({ 
      selectedMessages: newSelectedMessages,
      messageA: null
    });
  };

  toggleSourceModal = (message = null) => {
    this.setState({
      showSourceModal: !this.state.showSourceModal,
      currentSourceMessage: message
    });
  };

  renderSourceModal = () => {
    if (!this.state.currentSourceMessage) return null;

    return (
      <Modal
        show={this.state.showSourceModal}
        onHide={() => this.toggleSourceModal()}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Message Source - {this.state.currentSourceMessage.id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ 
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            maxHeight: '70vh',
            overflow: 'auto'
          }}>
            {JSON.stringify(this.state.currentSourceMessage, null, 2)}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.toggleSourceModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  toggleMessageCollapse = (messageId) => {
    console.log('toggleMessageCollapse', messageId);
    const messageElement = document.querySelector(`[data-message-id="${messageId}"]`);
    if (!messageElement) return;

    const isCollapsed = messageElement.classList.contains('collapsed');
    if (isCollapsed) {
      messageElement.classList.remove('collapsed');
      messageElement.style.height = 'auto';
    } else {
      messageElement.classList.add('collapsed');
      messageElement.style.height = '120px';
    }

    // Update icon
    const iconElement = messageElement.querySelector('.btn-collapse-message');
    if (iconElement) {
      iconElement.innerHTML = isCollapsed ? 
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path></svg>' :
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>';
    }

    // Update tooltip after a short delay to ensure DOM updates are complete
    setTimeout(() => {
      const button = messageElement.querySelector('.btn-collapse-message');
      if (button) {
        button.title = messageElement.classList.contains('collapsed') ? 
          'Hiện đầy đủ message' : 
          'Thu gọn message';
      }
    }, 50);

    // Update localStorage
    const newCollapsedMessages = { ...this.state.collapsedMessages };
    if (isCollapsed) {
      delete newCollapsedMessages[messageId];
    } else {
      newCollapsedMessages[messageId] = true;
    }
    this.setState({ collapsedMessages: newCollapsedMessages });
    localStorage.setItem('collapsedMessages', JSON.stringify(newCollapsedMessages));
  };

  renderAIMessage = (message, index, total, isSelectionMode, selectedMessages) => {
    console.log('renderAIMessage', message.id);
    var role = this.getAIMessageRole(message);
    var dateTime = message.message && message.message.create_time? moment(message.message.create_time * 1000).format("YY-MM-DD HH:mm:ss"): "no-data";
    var friendlyRoles = {
      'user': message.user_info.email,
      'assistant': 'ChatGPT',
      'assistant_tool': 'Tool',
      'assistant_system': 'System',
      'assistant_undefined': 'Assistant Undefined'
    }

    var conversation = {};

    try {
      conversation = this.state.aiConversations.filter(con => con.conversation_id == message.conversation_id)[0];
    } catch {
      // Handle case when conversation is not found
    }

    var content = `#### ${friendlyRoles[role]} (${dateTime}) \n`;
    var headerContentLength = content.length;

    if (this.state.showContentMarkdownV1 && message.content_markdown_v1) {
      content = message.content_markdown_v1;
    } else {
      try {
        var parts = message.message.content.parts.map(part => {
          if (part.content_type) {
            switch (part.content_type) {
              case "audio_transcription":
                return part.text;

              case "image_asset_pointer":
                // Debug logs
                console.log('Processing image part:', part);
                console.log('Asset pointer:', part.asset_pointer);
                
                let imageUrl = "";
                let imageId = "";
                
                if (part.asset_pointer.startsWith("sediment://")) {
                  imageId = part.asset_pointer.replace("sediment://", "");
                  imageUrl = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}/images/${imageId}_resized.png`;
                  console.log('Sediment image URL:', imageUrl);
                } else if (part.asset_pointer.startsWith("file-service://")) {
                  imageId = part.asset_pointer.replace("file-service://", "");
                  imageUrl = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}/images/${imageId}_resized.png`;
                  console.log('File service image URL:', imageUrl);
                }
                
                if (imageUrl) {
                  // Sử dụng cú pháp markdown để hiển thị ảnh
                  return `![${imageId}](${imageUrl})\n`;
                }
                return `[IMAGE ${part.asset_pointer}]\n`;
            }
          }

          try {
            var jsonData = JSON.parse(part);

            if (jsonData.type.includes("code")) {
              console.log("jsonData", jsonData);
              var docContent = "```" + jsonData.content + "```";
              jsonData.content = "@";

              return ["```" + JSON.stringify(jsonData) + "```", docContent].join("\n");
            };

            if (jsonData.type == "document") {
              console.log("jsonData", jsonData);
              var docContent = jsonData.content;
              jsonData.content = "@";

              return ["```" + JSON.stringify(jsonData) + "```", docContent].join("\n");
            };

            if (jsonData.updates) {
              var jsonContents = jsonData.updates.map(update => {
                var jsonContent = "```" + update.replacement + "```";
                update.replacement = "@";
                return jsonContent;
              })

              return ["```" + JSON.stringify(jsonData) + "```", jsonContents.join("\n --- n")].join("\n");
            }
          } catch {

          }

          // Thêm xử lý cho text thông thường
          if (typeof part === 'string') {
            // Thay thế \n bằng \n\n để đảm bảo markdown hiểu đây là dòng mới
            return part;
            // return part.replace(/\n/g, '\n\n');
          }

          return part;
        })

        content += parts.join("\n");

        if (message.message.metadata.content_references) {
          var contentReferences = message.message.metadata.content_references;
          contentReferences.map(ref => {
            if (ref.matched_text.trim())
              content = content.replace(ref.matched_text, ref.alt);
          });
        }

        // code text
        if (message.message.content.text) {
          content += `\n\n\`\`\`${message.message.content.text}\`\`\``;
        }

        // Xử lý attachments nếu có
        if (message.message.metadata.attachments && message.message.metadata.attachments.length > 0) {
          const attachments = message.message.metadata.attachments;
          const attachmentsText = attachments.map(att => 
            `\n\n📎 [${att.name}](${CONFIGS.API_URL}/files/${att.id})`
          ).join('');
          content += attachmentsText;
        }

        content = replaceAllText(content, ":::contextList", "---");
        content = replaceAllText(content, ":::contextList", "---");

      } catch (e) {
        console.log(e);
      }

      this.aiMessageMarkdownObj[message.id] = content;
    }

    if (!this.state.showAllMessages && content.length == headerContentLength)
      return "";

    var extraComponent = "";
    if (this.state.viewMode === '2-column') {
      extraComponent = (role == this.preRole) || 
                      (role.split("_")[0] == "assistant" && index == 1) || 
                      (this.preRole && role && 
                       this.preRole.split("_")[0] === "assistant" && 
                       role.split("_")[0] === "assistant") ? <Col md="6"></Col> : "";
    }
    this.preRole = role;

    var messageComponent = <Col md={this.state.viewMode === '2-column' ? '6' : '12'} className="p-2" title={`Message ID: ${message.id}`} data-message-id={message.id}>
      <div className={`p-3 pt-1 ai-message-item message-bg-${role}`} style={{ 
        position: 'relative',
        overflow: 'hidden',
        maxHeight: '100%'
      }}>
          {isSelectionMode && (
            <Form.Check
              type="checkbox"
              checked={selectedMessages.has(message.id)}
              onChange={() => this.handleMessageSelect(message.id)}
              className="message-checkbox"
              style={{ 
                position: 'absolute', 
                top: '5px', 
                left: '12px', 
                zIndex: 1,
                margin: 0,
                padding: 0,
                cursor: 'pointer'
              }}
            />
          )}

          {(message.conversation_turn && Number(message.conversation_turn) !== 0) ? (
            <span 
              style={{
                position: 'absolute',
                top: '5px',
                left: isSelectionMode ? '35px' : '5px',
                backgroundColor: message.conversation_turn % 2 === 0 ? '#2196F3' : '#ffd700',
                color: message.conversation_turn % 2 === 0 ? '#fff' : '#000',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: 'bold',
                zIndex: 2
              }}
              title={`Conversation turn ${message.conversation_turn}`}
            >
              #{message.conversation_turn}
            </span>
          ) : ""}

          <BsFillBookmarkPlusFill
            className="btn-add-to-collection"
            title="Add to Collection"
            onClick={e => this.showPopupAddToCollection(e, message.id)}
          />

          <Button
            variant="link"
            className="btn-collapse-message"
            onClick={() => this.toggleMessageCollapse(message.id)}
            style={{
              position: 'absolute',
              top: '40px',
              right: '13px',
              zIndex: 1,
              padding: '0',
              color: '#6c757d',
              opacity: 0,
              transition: 'opacity 0.2s ease-in-out'
            }}
            title={document.querySelector(`[data-message-id="${message.id}"]`)?.classList.contains('collapsed') ? 
              'Hiện đầy đủ message' : 
              'Thu gọn message'}
          >
            <BsChevronUp size={16} />
          </Button>

          {!this.state.messageId && (
          <Badge pill bg="danger" className="message-index-badge">
              {this.state.query.conversationId ? (
                `${dateTime} | ${index}/${total} | ${this.calculateTokens(content)} tokens`
              ) : conversation ? (
                <>
                  <a href={`/v1/k3pl-chat?conversationId=${conversation.conversation_id}`} 
                     target="_blank" 
                     rel="noopener noreferrer"
                     style={{ color: 'white', textDecoration: 'none' }}
                     onClick={(e) => e.stopPropagation()}
                     title={`Mở cuộc hội thoại ${conversation.title} trong tab mới`}>
                    {conversation.title}
                  </a>
                  {` | ${index}/${total} | ${this.calculateTokens(content)} tokens`}
                </>
              ) : (
                `${index}/${total} | ${this.calculateTokens(content)} tokens`
              )}
          </Badge>
          )}

          <div className="message-badges">
            <BsFileEarmarkArrowDown
              className="message-download-badge" 
              title="Download Markdown"
              onClick={e => this.downloadMessageContent(message)}
            />
            <BsClipboardCheck
              className="message-copy-badge"
              title="Copy Content"
              onClick={e => this.copyMessageContent(message)}
            />
            <BsLink45Deg
              className="message-link-badge"
              title="Open message in new tab"
              onClick={e => {
                e.stopPropagation();
                window.open(`/v1/k3pl-chat?messageId=${message.id}`, '_blank');
              }}
            />
            <BsChatSquareText
              className="message-link-badge message-link-conversation-badge"
              title="Open conversation in new tab"
              onClick={e => {
                e.stopPropagation();
                window.open(`/v1/k3pl-chat?conversationId=${message.conversation_id}`, '_blank');
              }}
            />
            <BsTrash
              className="message-delete-badge"
              title="Delete message"
              onClick={e => {
                e.stopPropagation();
                if (window.confirm('Bạn có chắc chắn muốn xóa tin nhắn này?')) {
                  this.handleDeleteMessage(message.id);
                }
              }}
            />
            <TbSourceCode
              className="message-source-badge"
              title="Show Source"
              onClick={() => this.toggleSourceModal(message)}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div className="message-content">
            <ReactMarkdown 
              // children={content.replaceAll("\n\n", "\n")}
              children={content}
              remarkPlugins={[
                remarkGfm,
                remarkBreaks,
                rehypeSlug,
                [remarkToc, { heading: 'Mục lục', tight: true }]
              ]}
              rehypePlugins={[
                rehypeRaw,
                rehypeHighlight,
                [rehypeAutolinkHeadings, { behavior: 'wrap' }],
                rehypeSanitize
              ]}
              components={{
                img: ImageModal,
                video: MarkdownVideo,
                // Custom styling for headings
                h1: ({node, ...props}) => <h1 style={{color: '#2c3e50', borderBottom: '2px solid #eee', paddingBottom: '0.3em'}} {...props} />,
                h2: ({node, ...props}) => <h2 style={{color: '#2c3e50', borderBottom: '1px solid #eee', paddingBottom: '0.3em'}} {...props} />,
                h3: ({node, ...props}) => <h3 style={{color: '#2c3e50'}} {...props} />,
                // Custom styling for code blocks
                code: ({node, inline, className, children, ...props}) => {
                  const match = /language-(\w+)/.exec(className || '');
                  return !inline && match ? (
                    <div className="code-block">
                      <div className="code-header">
                        <span className="language">{match[1]}</span>
                      </div>
                      <code className={className} {...props}>
                        {children}
                      </code>
                    </div>
                  ) : (
                    <code className={className} {...props}>
                      {children}
                    </code>
                  );
                },
                // Custom styling for blockquotes
                blockquote: ({node, ...props}) => (
                  <blockquote style={{
                    borderLeft: '4px solid #dfe2e5',
                    padding: '0 1em',
                    color: '#6a737d',
                    margin: '1em 0'
                  }} {...props} />
                ),
                // Custom styling for tables
                table: ({node, ...props}) => (
                  <div style={{overflowX: 'auto'}}>
                    <table style={{
                      borderCollapse: 'collapse',
                      width: '100%',
                      margin: '1em 0'
                    }} {...props} />
                  </div>
                ),
                th: ({node, ...props}) => (
                  <th style={{
                    border: '1px solid #dfe2e5',
                    padding: '6px 13px',
                    backgroundColor: '#f6f8fa'
                  }} {...props} />
                ),
                td: ({node, ...props}) => (
                  <td style={{
                    border: '1px solid #dfe2e5',
                    padding: '6px 13px'
                  }} {...props} />
                )
              }}
            />
          </div>
        </div>
      </Col>

    // Add style tag to head
    if (!document.getElementById('message-hover-styles')) {
      const style = document.createElement('style');
      style.id = 'message-hover-styles';
      style.textContent = `
        .ai-message-item:hover .btn-collapse-message {
          opacity: 1 !important;
        }
        [data-message-id].collapsed .ai-message-item .btn-collapse-message {
          opacity: 1 !important;
        }
      `;
      document.head.appendChild(style);
    }

    return <>
      {extraComponent}
      {messageComponent}
    </>;
  }

  handleSelectConversation = (selectedOption) => {
    const selectedConversationId = selectedOption ? selectedOption.value : "";
    const { query } = this.state;

    if (selectedConversationId || this.state.query.keyword) {
      this.preRole = "";
      this.setState({
        query: {
          ...query,
          conversationId: selectedConversationId
        },
        aiMessages: null,
        isLoading: true
      }, () => {
        this.updateURLQuery(this.state.query);
        this.props.getAIMessages(this.state.query);
      });
    } else {
      this.setState({
        query: {
          ...query,
          conversationId: ""
        },
        aiMessages: null
      }, () => {
        this.updateURLQuery(this.state.query);
      });
    }
  };

  handleSelectCollection = (e) => {
    e.preventDefault();
    console.log("handleSelectCollection", e.target.value);
    var selectedCollectionId = e.target.value;
    
    if (selectedCollectionId === "new") {
      // Nếu chọn "Add new collection", hiển thị input để nhập tên mới
      const newName = prompt("Enter new collection name:");
      if (newName) {
        this.props.addNewCollection(newName);
        this.setState({ selectedCollectionId: "" });
      } else {
        this.setState({ selectedCollectionId: "" });
      }
    } else {
    this.setState({ selectedCollectionId });
    }
  }

  isNeedUpdateContentMarkdownV1 = (message) => {
    return !message.content_markdown_v1  || 
    (!this.state.showContentMarkdownV1 && (message.content_markdown_v1 != this.aiMessageMarkdownObj[message.id]));
  }

  handleUpdateMessageMarkdown = () => {
    const messages = this.state.aiMessages || [];
    const aiMessages = messages
      .filter(message => this.isNeedUpdateContentMarkdownV1(message))
      .map(message => ({
        ...message,
        content_markdown_v1: this.aiMessageMarkdownObj[message.id]
      }))

    aiMessages.length && this.props.updateAIMessages(aiMessages, this.state.query);
  }

  handleChangeKeywordClient = (e) => {
    e.preventDefault();
    this.preRole = "";
    // Chỉ cập nhật giá trị input, không cập nhật query
    this.setState({ filterInput: e.target.value });
  }

  handleChangeKeyword = (e) => {
    e.preventDefault();
    // Chỉ cập nhật giá trị input, không cập nhật query
    this.setState({ searchInput: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // Khi nhấn Search, cập nhật query và tìm kiếm
    const newQuery = { ...this.state.query, keyword: this.state.searchInput };
    this.setState({ 
      query: newQuery, 
      aiMessages: null,
      isLoading: true 
    }, () => {
      this.updateURLQuery(newQuery);
      this.props.getAIMessages(newQuery);
    });
  }

  toggleCheckboxCollection(e, messageId, collectionId) {
    e.preventDefault();
    e.stopPropagation();
    console.log('addListingToCollection', messageId, collectionId);

    var message = this.state.aiMessages.filter(message => message.id == messageId)[0];
    console.log("XXX", message);
    this.props.toggleMessageInCollection(message, collectionId);
  }

  handleChangeCollectionName = (e) => {
    e.stopPropagation();
    this.setState({ newCollectionName: e.target.value });
  }

  addNewCollection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.addNewCollection(this.state.newCollectionName);
  }

  renderCheckboxCollections = () => {
    return <Form>
      {this.state.collections.map(collection => <>
        <Form.Check
          type='checkbox'
          label={collection.name}
          checked={collection.message_ids && collection.message_ids.indexOf(this.state.selectedMessageId) >= 0}
          onClick={e => this.toggleCheckboxCollection(e, this.state.selectedMessageId, collection._id)}
        />
      </>)}
    </Form>
  }

  handleAddFilterMessagesToCollection = (e) => {
    var collection = this.state.collections.filter(collection => collection._id == this.state.selectedCollectionId)[0];
    var messageIds = collection.message_ids ? collection.message_ids.split(",") : [];
    var messageCount = 0;

    // Thêm các message đã chọn vào collection
    this.state.selectedMessages.forEach(messageId => {
      if (!messageIds.includes(messageId)) {
        messageIds.push(messageId);
        messageCount++;
      }
    });

    collection.message_ids = messageIds.join(",");

    this.props.updateCollection(collection);
    
    // Reset selection mode và selected messages sau khi thêm vào collection
    this.setState({ 
      isSelectionMode: false,
      selectedMessages: new Set()
    }, () => {
      toast.success(`Đã thêm ${messageCount} tin nhắn vào bộ sưu tập "${collection.name}"`);
    });
  }

  handleRemoveFromCollection = () => {
    if (!this.state.collectionId || this.state.selectedMessages.size === 0) return;

    const collection = this.state.currentCollection;
    let messageIds = collection.message_ids ? collection.message_ids.split(",") : [];
    let removedCount = 0;

    // Xóa các message đã chọn khỏi collection
    this.state.selectedMessages.forEach(messageId => {
      const index = messageIds.indexOf(messageId);
      if (index > -1) {
        messageIds.splice(index, 1);
        removedCount++;
      }
    });

    collection.message_ids = messageIds.join(",");

    this.props.updateCollection(collection);
    
    // Xóa các message đã chọn khỏi các mảng liên quan
    const newAiMessages = this.state.aiMessages.filter(
      message => !this.state.selectedMessages.has(message.id)
    );
    const newFilteredMessages = this.state.filteredMessages.filter(
      message => !this.state.selectedMessages.has(message.id)
    );
    
    // Reset selection mode và selected messages sau khi xóa
    this.setState({ 
      isSelectionMode: false,
      selectedMessages: new Set(),
      aiMessages: newAiMessages,
      filteredMessages: newFilteredMessages
    }, () => {
      toast.success(`Đã xóa ${removedCount} tin nhắn khỏi bộ sưu tập "${collection.name}"`);
    });
  }

  renderCollectionBox = () => {
    return <Card
      id="popup-add-to-collection"
      bg="light"
      border="dark"
      text="dark"
    >
      {/* <Card.Header className="text-center">Header</Card.Header> */}
      <Card.Title className="text-center mt-2 mb-2">Thêm vào Bộ Sưu Tập</Card.Title>

      <Card.Body id="collections-list">
        {this.renderCheckboxCollections()}
      </Card.Body>

      <Card.Footer>
        <Form>
          <Form.Control
            size="sm"
            type="text"
            placeholder="Collection Name"
            id="input-add-new-collection"
            value={this.state.newCollectionName}
            onChange={this.handleChangeCollectionName}
            onClick={e => { e.stopPropagation(); }}
          />
          <Button
            className="btn-fill pull-right btn-sm"
            id="btn-add-new-collection"
            disabled={this.state.newCollectionName == ""}
            type="submit"
            variant="primary"
            onClick={this.addNewCollection}
          >
            Thêm
          </Button>
        </Form>
      </Card.Footer>
    </Card>
  }

  downloadAllSelectedMessages = async () => {
    if (this.state.selectedMessages.size === 0) {
      toast.error("Please select at least one message to download");
      return;
    }

    try {
      const zip = new JSZip();
      
      // Lấy các message đầy đủ từ filteredMessages
      const selectedFullMessages = this.state.filteredMessages.filter(
        message => this.state.selectedMessages.has(message.id)
      );
      
      for (const message of selectedFullMessages) {
        if (!message.content_markdown_v1) continue;
        
        let content = message.content_markdown_v1;
        let filename = `message.md`;

        // Kiểm tra và xử lý tên file đặc biệt
        const filenameMatch = content.match(/@K3PL_SAVE_MESSAGE_FILENAME:\s*(.+?)(?:\n|$)/);
        if (filenameMatch) {
          // Lấy tên file từ match
          filename = filenameMatch[1].trim();
          // Xóa dòng chứa tên file khỏi nội dung
          content = content.replace(/@K3PL_SAVE_MESSAGE_FILENAME:\s*(.+?)(?:\n|$)/, '');
          // Thay thế dấu : bằng dấu -
          filename = filename.replace(/:/g, 'h');
        } else {
          // Tạo tên file theo định dạng mới
          const role = this.getAIMessageRole(message);
          const date = new Date(message.message.create_time * 1000);
          const formattedDate = date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }).replace(/[\/:]/g, '').replace(/,/g, '_');
          
          filename = `message_${formattedDate}_${role}.md`;
        }

        // Thêm thông tin conversation_id và message_id vào cuối file
        const fullContent = `${content}\n\nCONVERSATION_ID = ${message.conversation_id}\nMESSAGE_ID = ${message.id}`;
        zip.file(filename, fullContent);

        // Kiểm tra nếu là AI Review Report
        if (content.includes("REPORT_TYPE: AI_REVIEW") && 
            content.includes("REVIEW_QUESTIONS") && 
            content.includes("REVIEW_ANSWERS")) {
          
          // Tách nội dung thành 3 phần
          const questionsIndex = content.indexOf("REVIEW_QUESTIONS");
          const answersIndex = content.indexOf("REVIEW_ANSWERS");
          
          // Xác định loại review (AI hoặc ME)
          const isAIReview = content.includes("AI_REVIEW_AI");
          const isMEReview = content.includes("AI_REVIEW_ME");
          const isContentReview = content.includes("AI_REVIEW_CONTENT");
          const reviewType = isAIReview ? "ai" : (isMEReview ? "me" : (isContentReview ? "content" : ""));
          
          // Tạo tên base cho file
          const date = new Date(message.message.create_time * 1000);
          const formattedDate = date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }).replace(/[\/:]/g, '').replace(/,/g, '_');
          
          const baseFilename = `profile_${reviewType}_${formattedDate}`;
          
          // Phần 1: Content
          const contentPart = content.substring(0, questionsIndex).trim();
          const contentFilename = `${baseFilename}_content.md`;
          zip.file(contentFilename, `${contentPart}\n\nCONVERSATION_ID = ${message.conversation_id}\nMESSAGE_ID = ${message.id}`);
          
          // Phần 2: Questions
          const questionsPart = content.substring(questionsIndex, answersIndex).trim();
          const questionsFilename = `${baseFilename}_questions.md`;
          zip.file(questionsFilename, `${questionsPart}\n\nCONVERSATION_ID = ${message.conversation_id}\nMESSAGE_ID = ${message.id}`);
          
          // Phần 3: Answers
          const answersPart = content.substring(answersIndex).trim();
          const answersFilename = `${baseFilename}_answers.md`;
          zip.file(answersFilename, `${answersPart}\n\nCONVERSATION_ID = ${message.conversation_id}\nMESSAGE_ID = ${message.id}`);
        }
      }

      // Generate zip file
      const zipContent = await zip.generateAsync({ type: "blob" });
      
      // Create download link
      const url = window.URL.createObjectURL(zipContent);
      const link = document.createElement('a');
      link.href = url;
      // Nếu đang ở Collection Mode, sử dụng tên collection
      const now = new Date();
      const formattedDateTime = now.toISOString()
        .replace('T', '_')
        .replace(/\..+/, '')
        .replace(/:/g, '-');
      const zipFilename = this.state.collectionId ? 
        `${this.state.currentCollection.name}-${formattedDateTime}.zip` :
        `selected-messages-${formattedDateTime}.zip`;
      link.download = zipFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Messages downloaded successfully");
    } catch (error) {
      console.error("Error downloading messages:", error);
      toast.error("Failed to download messages");
    }
  };

  handleDeleteConversation = async (conversation) => {
    if (window.confirm(`Are you sure you want to delete conversation "${conversation.title}"?`)) {
      try {
        await this.props.updateAiConversation({
          _id: conversation._id,
          is_deleted: true
        });
        toast.success('Conversation deleted successfully');
        // Redirect to main page
        window.location.href = '/v1/k3pl-chat';
      } catch (error) {
        console.error('Error deleting conversation:', error);
        toast.error('Failed to delete conversation');
      }
    }
  };

  handleOpenConversation = () => {
    const { selectedChatTask } = this.state;
    if (!selectedChatTask) return;

    const currentTask = this.state.k3tasks.find(t => t._id === selectedChatTask);
    if (!currentTask) return;

    // Get conversation_id from URL
    const searchParams = new URLSearchParams(window.location.search);
    const conversationId = searchParams.get('conversationId');
    if (!conversationId) {
      toast.error('No conversation ID found in URL');
      return;
    }

    const jobData = {
      task_id: selectedChatTask,
      agent_id: currentTask.target_agent_id,
      job_id: 2,
      job_content: { conversation_id: conversationId }
    };

    this.props.assignAgentJob(jobData);
    toast.success('Opening conversation...');
  };

  handleSendChatMessage = () => {
    const { selectedChatTask, chatMessage } = this.state;
    if (!selectedChatTask || !chatMessage) return;

    const currentTask = this.state.k3tasks.find(t => t._id === selectedChatTask);
    if (!currentTask) return;

    // Lấy conversation_id từ URL
    const searchParams = new URLSearchParams(window.location.search);
    const conversationId = searchParams.get('conversationId');

    const jobData = {
      task_id: selectedChatTask,
      agent_id: currentTask.target_agent_id,
      job_id: 4,
      job_content: { text: chatMessage, conversation_id: conversationId }
    };

    this.props.assignAgentJob(jobData);
    // Clear message after sending
    this.setState({ chatMessage: '' });
    // Show success toast
    toast.success('Message sent successfully!');

    // Start polling for new messages
    const initialMessageCount = this.state.filteredMessages.length;
    const pollInterval = setInterval(() => {
      this.props.getAIMessages(this.state.query).then(() => {
        // If we got new messages, stop polling
        if (this.state.filteredMessages.length > initialMessageCount) {
          clearInterval(pollInterval);
        }
      });
    }, 3000); // Poll every 3 seconds

    // Store interval ID in state so we can clear it if needed
    this.setState({ messagePollInterval: pollInterval });
  };

  getAgentName = (agentId) => {
    const agent = this.state.k3agents.find(a => a._id === agentId);
    return agent ? `${agent.name}` : 'Unknown';
  };

  getWebUrl = () => {
    const { query } = this.state;
    if (!query.conversationId) return null;

    const conversation = this.state.aiConversations.find(con => con.conversation_id === query.conversationId);
    if (!conversation) return null;

    const aiSystemType = conversation.ai_system_type || 'chatgpt'; // Default to chatgpt if not specified
    return aiSystemType === 'deepseek' 
      ? `https://chat.deepseek.com/a/chat/s/${query.conversationId}`
      : `https://chatgpt.com/c/${query.conversationId}`;
  };

  render() {
    const { filteredMessages, isLoading } = this.state;
    const { keyword, filterKeyword } = this.state.query;
    const isMessageMode = !!this.state.messageId;

    console.log("RE-RENDER");
    // console.log("this.state.selectedMessages length", this.state.selectedMessages.length);
    // console.log("this.state.filteredMessages length", this.state.filteredMessages.length);

    return (
      <>
        <Toaster position="top-right" />
        <Container fluid id="k3pl-chat-page"
          className="paper-style"
          onClick={this.handleClick}
          style={{ 
            height: 'calc(100vh - 40px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          {isLoading && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}>
              <FerrisWheelSpinner loading={true} color="#17a2b8" />
            </div>
          )}
          {this.renderCollectionBox()}

          {!isMessageMode && (
            <>
              {this.state.showMenu && (
                <Row style={{ flexShrink: 0 }}>
                  {!this.state.collectionId ? (
                    <Col md="3">
                      <InputGroup className="mb-3">
                        <InputGroup.Text className="btn-sm" id="basic-addon1" style={{ flex: '0 0 auto' }}>Conversation</InputGroup.Text>
                        <div style={{ flex: 1 }}>
                          <Select
                            value={this.state.aiConversations.find(con => con.conversation_id === this.state.query.conversationId) ? {
                              value: this.state.query.conversationId,
                              label: `${this.state.aiConversations.find(con => con.conversation_id === this.state.query.conversationId).title}`
                            } : null}
                            onChange={this.handleSelectConversation}
                            options={[
                              { value: "", label: "All" },
                              ...this.state.aiConversations
                                .filter(con => !con.is_deleted)
                                .map(con => ({
                                  value: con.conversation_id,
                                  label: `${con.title}`
                                }))
                            ]}
                            isSearchable={true}
                            placeholder="Select ..."
                            className="react-select-container"
                            classNamePrefix="react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                width: '100%',
                                fontSize: '0.875rem',
                                borderRadius: '0.25rem'
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                width: '100%',
                                padding: '0 6px'
                              }),
                              input: (base) => ({
                                ...base,
                                margin: '0px',
                                width: '100%'
                              }),
                              indicatorsContainer: (base) => ({
                                ...base
                              })
                            }}
                          />
                        </div>
                      </InputGroup>
                    </Col>
                  ) : (
                    <Col md="3" className="mt-2">
                      Collection: <b>{this.state.currentCollection.name}</b>
                    </Col>
                  )}
                  {!this.state.collectionId && (
                    <Col md="3">
                      <InputWithButton
                        value={this.state.searchInput}
                        onChange={this.handleChangeKeyword}
                        placeholder="Enter keyword"
                        label="Search"
                        buttonText="Search"
                        buttonVariant="primary"
                        onButtonClick={this.handleSubmit}
                        disabled={false}
                      />
                  </Col>
                  )}

                  <Col md="3">
                    <InputGroup className="mb-3">
                      <InputGroup.Text className="btn-sm">Filter Keyword</InputGroup.Text>
                      <Form.Control
                        className='text-red'
                          value={this.state.filterInput}
                        onChange={this.handleChangeKeywordClient}
                        placeholder="Enter keyword"
                        aria-label="keyword"
                        aria-describedby="basic-addon1"
                      />
                        {this.state.filterInput && (
                          <Button
                            variant="outline-secondary"
                            className="btn-sm"
                            onClick={() => {
                              this.preRole = ""; // Reset preRole khi xóa filter input
                              const newQuery = {
                                ...this.state.query,
                                filterKeyword: ""
                              };
                              this.setState({ 
                                filterInput: "",
                                isFilterByKeyword: false,
                                query: newQuery
                              }, () => {
                                this.updateFilteredMessages();
                                this.updateURLQuery(newQuery);
                              });
                            }}
                          >
                            <BsX />
                          </Button>
                        )}
                        <Form.Check
                          type="checkbox"
                          checked={this.state.isFilterByKeyword}
                          onChange={(e) => {
                            const newIsFilterByKeyword = e.target.checked;
                            const newQuery = { 
                              ...this.state.query, 
                              filterKeyword: this.state.filterInput 
                            };
                            
                            this.preRole = ""; // Reset preRole khi bật/tắt filter
                            
                            this.setState({ 
                              isFilterByKeyword: newIsFilterByKeyword,
                              query: newQuery
                            }, () => {
                              this.updateFilteredMessages();
                              this.updateURLQuery(newQuery);
                            });
                          }}
                          label="Filter"
                          className="ms-2 mt-2"
                        />
                    </InputGroup>
                  </Col>

                  <Col md="3">
                    <InputGroup className="mb-3">
                      <InputGroup.Text className="btn-sm" id="basic-addon1">Collection</InputGroup.Text>
                      <Form.Select aria-label=""
                        value={this.state.selectedCollectionId}
                        onChange={this.handleSelectCollection}
                        // style={{ maxWidth: 180 }}
                      >
                        <option value="">All</option>
                        {this.state.collections
                          .map(collection => (
                            <option value={collection._id}>
                              {collection.name} | ({collection.message_ids ? collection.message_ids.split(",").length : 0})
                            </option>
                          ))}
                        <option value="new">+ Add new collection</option>
                      </Form.Select>
                      <ButtonGroup>
                        <Button
                          className="btn-fill btn-sm"
                          type="submit"
                          variant="primary"
                          disabled={this.state.isFilterByKeyword || this.state.selectedCollectionId == "" || this.state.selectedCollectionId === "new"}
                          onClick={this.handleAddFilterMessagesToCollection}
                          style={{ minWidth: 60 }}
                        >
                          Add
                        </Button>
                      </ButtonGroup>
                    </InputGroup>
                  </Col>

                  <Col md="12" style={{ textAlign: "left" }}>
                    {!this.state.collectionId && (
                      <>
                  <Button
                          className="btn-fill pull-left btn-sm me-2"
                    type="submit"
                          variant="danger"
                          disabled=""
                          onClick={e => this.handleUpdateMessageMarkdown()}
                          style={{ display: this.state.filteredMessages.some(msg => this.isNeedUpdateContentMarkdownV1(msg)) ? 'inline-block' : 'none' }}
                        >
                          Update Markdown
                  </Button>
                      </>
                    )}
                    <div className="d-inline-block me-3 p-2 border rounded" style={{ verticalAlign: 'middle' }}>
                      <span className="me-2 fw-bold">Display:</span>
                      <Form.Check
                        type="checkbox"
                        checked={this.state.showContentMarkdownV1}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          localStorage.setItem('showContentMarkdownV1', newValue);
                          this.aiMessageMarkdownObj = {}; // Reset aiMessageMarkdownObj
                          this.setState({ 
                            showContentMarkdownV1: newValue,
                            messagesByRole: null,
                            filteredMessages: [] // Reset filteredMessages
                          }, () => {
                            // Force re-render by updating filteredMessages
                            const messages = this.state.aiMessages || [];
                            this.messagesByRole = this.filterMessagesByRole(messages);
                            this.updateFilteredMessages();
                          });
                        }}
                        label="Content V1"
                        className="d-inline-block me-3"
                      />
                      <Form.Check
                        type="checkbox"
                        checked={this.state.showToolMessages}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          localStorage.setItem('showToolMessages', newValue);
                          this.setState({ 
                            showToolMessages: newValue,
                            messagesByRole: null
                          }, () => {
                            this.updateFilteredMessages();
                          });
                        }}
                        label="Tool Messages"
                        className="d-inline-block me-3"
                      />
                      <Form.Check
                        type="checkbox"
                        checked={this.state.showAllMessages}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          localStorage.setItem('showAllMessages', newValue);
                          this.setState({ 
                            showAllMessages: newValue,
                            messagesByRole: null
                          }, () => {
                            this.updateFilteredMessages();
                          });
                        }}
                        label="All Messages"
                        className="d-inline-block me-3"
                      />
                      <Form.Check
                        type="checkbox"
                        checked={this.state.showImportMessages}
                        onChange={e => {
                          const checked = e.target.checked;
                          this.setState({ showImportMessages: checked }, () => {
                            localStorage.setItem('showImportMessages', checked);
                            this.updateFilteredMessages();
                          });
                        }}
                        label="Import Message"
                        className="d-inline-block me-3"
                      />
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={this.handleToggleViewMode}
                        className="d-inline-block ms-3"
                        title={`Switch to ${this.state.viewMode === '2-column' ? '1-column' : '2-column'} view`}
                      >
                        {this.state.viewMode === '2-column' ? '2-Column' : '1-Column'} View
                      </Button>
                    </div>
                    <div className="d-inline-block me-3 p-2 border rounded" style={{ verticalAlign: 'middle' }}>
                      <span className="me-2 fw-bold">Selection:</span>
                      <Form.Check
                        type="checkbox"
                        checked={this.state.isSelectionMode}
                        onChange={this.handleToggleSelectionMode}
                        label="Enable"
                        className="d-inline-block me-3"
                      />
                      {this.state.isSelectionMode && (
                        <>
                          <Form.Check
                            type="checkbox"
                            checked={this.state.selectedMessages.size === this.state.filteredMessages.length}
                            onChange={this.handleSelectAll}
                            label="Select All"
                            className="d-inline-block me-3"
                          />
                          <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={this.handleDeselectAll}
                              className="me-3"
                            >
                              Deselect All
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={this.handleSelectAB}
                            className="me-3"
                            disabled={!this.state.messageA || !this.state.messageB}
                          >
                            Select AB
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={this.handleSelectAZ}
                            className="me-3"
                          >
                            Select AZ
                          </Button>
                          <span className="me-3">({this.state.selectedMessages.size} selected)</span>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={this.downloadAllSelectedMessages}
                            className="me-3"
                          >
                            <BsFileEarmarkArrowDown className="me-1" />
                            Download All
                          </Button>
                          {this.state.collectionId && (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={this.handleRemoveFromCollection}
                              className="me-3"
                            >
                              <BsTrash className="me-1" />
                              Remove from Collection
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                    <div className="d-inline-block me-3 p-2 border rounded" style={{ verticalAlign: 'middle' }}>
                      <Form.Check
                        type="checkbox"
                        checked={this.state.showImportMessages}
                        onChange={e => {
                          const checked = e.target.checked;
                          this.setState({ showImportMessages: checked }, () => {
                            localStorage.setItem('showImportMessages', checked);
                            this.updateFilteredMessages();
                          });
                        }}
                        label="Import Message"
                        className="d-inline-block me-3"
                      />
                    </div>

                    <div className="d-flex align-items-center float-end" style={{ gap: 8 }}>
                      <>
                        {this.state.query.conversationId && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            style={{ verticalAlign: 'middle', padding: '2px 6px' }}
                            title="Open in new tab"
                            onClick={() => window.open(`https://chatgpt.com/c/${this.state.query.conversationId}`, '_blank')}
                          >
                            <BsLink45Deg />
                          </Button>
                        )}

                        <CommitCreator 
                          selectedMessages={this.state.selectedMessages}
                          onMessageSelect={this.handleMessageSelect}
                          onStartCommit={() => {
                            this.setState({ 
                              isSelectionMode: true,
                              selectedMessages: new Set()
                            });
                          }}
                          onResetSelection={() => {
                            this.setState({ 
                              selectedMessages: new Set()
                            });
                          }}
                          onCommitCreated={() => {
                            this.setState({ 
                              isSelectionMode: false,
                              selectedMessages: new Set()
                            });
                          }}
                        />
                      </>
                      {this.state.selectedMessages.size > 0 && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="ms-2"
                          style={{ display: 'inline-block', verticalAlign: 'middle' }}
                          onClick={() => {
                            if (window.confirm(`Are you sure you want to delete ${this.state.selectedMessages.size} selected messages?`)) {
                              this.state.selectedMessages.forEach(messageId => {
                                this.handleDeleteMessage(messageId);
                              });
                            }
                          }}
                          title="Delete selected messages"
                        >
                          <BsTrash className="me-1" />
                          Delete
                        </Button>
                      )}
                    </div>

                  </Col>
                </Row>
              )}
            </>
          )}

          <Row className="mt-2">
            {!isMessageMode && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ flex: 1 }}>
                  <MessageHeader 
                    keyword={this.state.query.keyword}
                    filterKeyword={this.state.query.filterKeyword}
                    isFilterByKeyword={this.state.isFilterByKeyword}
                    messageCount={filteredMessages.length}
                    messages={filteredMessages}
                  />
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const newShowMenu = !this.state.showMenu;
                    this.setState({ showMenu: newShowMenu });
                    // Update URL
                    const searchParams = new URLSearchParams(window.location.search);
                    if (newShowMenu) {
                      searchParams.delete('show_menu');
                    } else {
                      searchParams.set('show_menu', 'false');
                    }
                    const newURL = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
                    window.history.pushState({}, '', newURL);
                  }}
                  title={this.state.showMenu ? "Ẩn menu" : "Hiện menu"}
                  style={{ marginLeft: 16 }}
                >
                  {this.state.showMenu ? <BsChevronUp /> : <BsChevronDown />}
                </Button>
              </div>
            )}
          </Row>

          <Row style={{ 
            flex: 1,
            overflow: 'hidden',
            margin: 0
          }}>
            <div style={{ 
              height: '100%',
              overflowY: 'auto',
              padding: '0 15px'
            }}>
              <Row>
                <MessageList 
                  key={`${this.state.viewMode}-${this.state.filteredMessages.length}`}
                  messages={filteredMessages} 
                  renderMessage={this.renderAIMessage}
                  isSelectionMode={this.state.isSelectionMode}
                  selectedMessages={this.state.selectedMessages}
                />
          </Row>
            </div>
          </Row>

          {/* Chat Component */}
          <Card className="mt-2 mb-2">
            <Card.Body>
              <Row>
                <Col md={3}>
                  <Form.Select
                    value={this.state.selectedChatTask || ''}
                    onChange={(e) => {
                      this.setState({ selectedChatTask: e.target.value });
                      localStorage.setItem('selectedChatTask', e.target.value);
                    }}
                  >
                    <option value="">Select Task</option>
                    {this.state.k3tasks.map(task => (
                      <option key={task._id} value={task._id}>
                        {task.name} ({this.getAgentName(task.target_agent_id)})
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type="text"
                    placeholder="Enter message..."
                    value={this.state.chatMessage || ''}
                    onChange={(e) => this.setState({ chatMessage: e.target.value })}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        this.handleSendChatMessage();
                      }
                    }}
                  />
                </Col>
                <Col md={2}>
                  <div className="d-flex gap-2">
                    <Button 
                      variant="primary" 
                      style={{ minWidth: 90, color: '#222' }}
                      onClick={this.handleSendChatMessage}
                      disabled={!this.state.selectedChatTask || !this.state.chatMessage}
                    >
                      Send
                    </Button>
                    {this.getWebUrl() && (
                      <Button
                        variant="outline-primary"
                        style={{ minWidth: 90 }}
                        onClick={() => window.open(this.getWebUrl(), '_blank')}
                        title="Open in ChatGPT/Deepseek"
                      >
                        Open Web
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>

        {/* Nút scroll to top */}
        {this.state.showScrollTop && (
          <Button
            className="scroll-to-top"
            variant="primary"
            onClick={this.scrollToTop}
            title="Scroll to top"
            style={{
              position: 'fixed',
              bottom: '70px',
              right: '20px',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease'
            }}
          >
            <BsArrowUpCircleFill size={24} />
          </Button>
        )}

        {/* Nút scroll to bottom */}
        {this.state.showScrollBottom && (
          <Button
            className="scroll-to-bottom"
            variant="primary"
            onClick={this.scrollToBottom}
            title="Scroll to bottom"
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center', 
              zIndex: 1000,
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease'
            }}
          >
            <BsArrowDownCircleFill size={24} />
          </Button>
        )}
        {this.renderSourceModal()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    aiConversations: state.aiConversationReducer.aiConversations,
    aiMessages: state.aiMessageReducer.aiMessages,
    collections: state.collectionReducer.collections,
    k3tasks: state.k3taskReducer.k3tasks,
    k3agents: state.k3agentReducer.k3agents
  }
}

export default connect(mapStateToProps, {
  getAIConversations,
  getAIMessages,
  updateAIMessages,
  getAllCollections,
  addNewCollection,
  toggleMessageInCollection,
  updateCollection,
  deleteAIMessage,
  updateAiConversation,
  assignAgentJob,
  getK3Tasks,
  getK3Agents
})(K3PLChat);